// lib
import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import PageGlobals from '@aytm/app/stats/lib/page/page-globals'

// components
import { Button } from 'primereact/button'
import { RadioButton } from 'primereact/radiobutton'

// styles
import style from '@aytm/app/stats/page/sidebar/export/styles/ExportPanel.module.scss'

// Shared by the two shapes below: a disabled print draft is not a link, so it is rendered as one
// only when it can be followed.
const PRINT_LABEL = (
  <>
    <i className="icon-aytmfd-print-v2" />
    <span className="p-button-label">Print survey draft</span>
  </>
)

const Questionnaire = ({ processing, disabled, onExport }) => {
  const [exportType, setExportType] = useState('draft-doc')

  return (
    <>
      <div className={style.section}>
        <div className={`${style.row} ${style['row-indent']}`}>
          <div className={`${style.param} p-col-12`}>
            <RadioButton
              data-testid="stat-exports-questionnaire-draft-doc"
              className="p-radiobutton-sm"
              aria-labelledby="stat-exports-questionnaire-draft-doc-label"
              value="draft-doc"
              checked={'draft-doc' == exportType}
              disabled={null !== processing || disabled}
              onChange={null !== processing || disabled ? null : () => setExportType('draft-doc')}
            />
            <span
              data-testid="stat-exports-questionnaire-draft-doc-label"
              id="stat-exports-questionnaire-draft-doc-label"
              className={classNames(style['row-label'], style['row-label-sm'], {
                'p-disabled': processing || disabled
              })}
              onClick={null !== processing || disabled ? null : () => setExportType('draft-doc')}
            >
              Survey draft
            </span>
          </div>
        </div>
        <div className={`${style.row} ${style['row-indent']}`}>
          <div className={`${style.param} p-col-12`}>
            <RadioButton
              data-testid="stat-exports-questionnaire-draft-doc-comments"
              className="p-radiobutton-sm"
              aria-labelledby="stat-exports-questionnaire-draft-doc-comments-label"
              value="draft-doc-comments"
              checked={'draft-doc-comments' == exportType}
              disabled={null !== processing || disabled}
              onChange={null !== processing || disabled ? null : () => setExportType('draft-doc-comments')}
            />
            <span
              data-testid="stat-exports-questionnaire-draft-doc-comments-label"
              id="stat-exports-questionnaire-draft-doc-comments-label"
              className={classNames(style['row-label'], style['row-label-sm'], {
                'p-disabled': processing || disabled
              })}
              onClick={null !== processing || disabled ? null : () => setExportType('draft-doc-comments')}
            >
              Survey draft with comments
            </span>
          </div>
        </div>
      </div>
      <div className={style.section}>
        <div className={style.row}>
          <Button
            data-testid="stat-exports-questionnaire-export"
            className="p-button-rounded p-button-blue"
            icon={<i className="icon-aytmfd-word-v2" />}
            loading={'questionnaire' == processing}
            disabled={null !== processing || disabled}
            onClick={
              processing || disabled
                ? null
                : () =>
                    onExport({
                      fileType: 'draft',
                      exportType
                    })
            }
          >
            <span className="p-button-label">Download survey draft</span>
          </Button>
        </div>
        <div className={style.row}>
          {disabled ? (
            <span
              data-testid="stat-exports-questionnaire-print"
              className="p-component p-button p-button-rounded p-button-blue p-disabled"
              aria-disabled
            >
              {PRINT_LABEL}
            </span>
          ) : (
            <a
              data-testid="stat-exports-questionnaire-print"
              className="p-component p-button p-button-rounded p-button-blue"
              href={PageGlobals.DRAFT_SURVEY_PATH}
              target="_blank"
              rel="noopener noreferrer"
            >
              {PRINT_LABEL}
            </a>
          )}
        </div>
      </div>
    </>
  )
}

Questionnaire.propTypes = {
  processing: PropTypes.string,
  disabled: PropTypes.bool,
  onExport: PropTypes.func
}

Questionnaire.displayName = 'Questionnaire'

export default Questionnaire
